import * as Sentry from "@sentry/react";

/**
 * Erros do front no Sentry (DSN público via VITE_SENTRY_DSN; vazio = desligado)
 * e registro de telas abertas para a aba Métricas. Nada de dado de paciente:
 * só o caminho da tela (ids viram ":id" no servidor).
 */
export function initMonitoring() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (dsn) {
    Sentry.init({
      dsn,
      environment: import.meta.env.MODE,
      release: import.meta.env.VITE_APP_VERSION as string | undefined,
      tracesSampleRate: 0,
    });
  }
}

let queue: string[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

function flush() {
  timer = null;
  if (queue.length === 0) return;
  const paths = queue;
  queue = [];
  void fetch("/api/v1/metrics/screens", {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-App-Request": "1" },
    body: JSON.stringify({ paths }),
    keepalive: true,
  }).catch(() => undefined);
}

/** Tela aberta (só dentro de /app). Enviado em lote a cada 10 s. */
export function trackScreen(pathname: string) {
  if (!pathname.startsWith("/app")) return;
  queue.push(pathname);
  if (queue.length >= 20) flush();
  else if (!timer) timer = setTimeout(flush, 10_000);
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", flush);
}
